import { Box, Button } from '@material-ui/core';
import React, { useReducer, useCallback } from 'react';
import {
  globalModalActionType, globalModalContext, globalModalInitState, globalModalReducer,
} from '../contexts/globalModalContext';
import Alert from '../preorder/components/Alert';

export default (WrappedComponent) => (props) => {
  const [store, dispatch] = useReducer(globalModalReducer, globalModalInitState);
  const {
    title = '',
    content = '',
    callback = () => {},
    isOpen = false,
  } = store;

  const closeModal = useCallback(() => {
    dispatch({
      type: globalModalActionType.CLOSE_MODAL,
    });
  }, [dispatch]);

  const openModal = useCallback((data) => {
    const { callback: dataCallback = () => {} } = data;
    dispatch({
      type: globalModalActionType.OPEN_MODAL,
      payload: {
        ...data,
        callback: () => {
          dataCallback();
          closeModal();
        },
      },
    });
  }, [dispatch, closeModal]);

  return (
    <globalModalContext.Provider value={{ store, openModal }}>
      <Alert
        title={title}
        isOpen={isOpen}
        content={content}
        buttons={(
          <Button fullWidth onClick={callback}>
            <Box fontWeight="fontWeightBold" color="support.main">
              確認
            </Box>
          </Button>
        )}
      />
      <WrappedComponent {...props} />
    </globalModalContext.Provider>
  );
};
